export const languages = [
  {
    languageCode: "en",
    name: "English",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
  {
    languageCode: "pl",
    name: "Polish",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
  {
    languageCode: "de",
    name: "German",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
  {
    languageCode: "es",
    name: "Spanish",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
  {
    languageCode: "pt",
    name: "Portuguese",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
  {
    languageCode: "tr",
    name: "Turkish",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
  {
    languageCode: "fr",
    name: "French",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
  {
    languageCode: "ja",
    name: "Japanese",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
  {
    languageCode: "ch",
    name: "Chinese",
    value: "",
    rules: {
      required: { required: true },
    },
    display: false,
  },
];

export const ManageTranslationsDraftDefaultFields = {
  currentLiveVersion: {
    name: "CURRENT LIVE VERSION",
    value: "",
    rules: { title: "CURRENT LIVE VERSION", required: {required: false} },
  },
  currentLiveComments: {
    name: "CURRENT LIVE COMMENTS",
    value: "",
    hideCharCount: true,
    rules: { title: "CURRENT LIVE COMMENTS", required: {required: false} },
  },
  draftVersionComment: {
    name: "DRAFT VERSION COMMENTS",
    value: "",
    rules: {
      title: "DRAFT VERSION COMMENTS",
      required: {required: false},
    },
    hideCharCount: true,
    display: false,
  },
};

export const EditTranslationsDraftFields = {
  country: {
    name: "Country",
    value: "",
    rules: { title: "Country", required: true },
  },
  page: {
    name: "Page",
    value: "",
    rules: { title: "Page", required: true },
  },
  userType: {
    name: "User Type",
    value: "",
    rules: { title: "User Type", required: true },
  },
  section: {
    name: "Section",
    value: "",
    rules: { title: "Section", required: true },
  },
  element: {
    name: "Element",
    value: "",
    rules: { title: "Element", required: true },
  },
  draftVersionComment: {
    name: "Draft Version Comments",
    value: "",
    rules: {
      title: "Draft Version Comments",
      required: { required: false },
    },
    display: false,
  },
};

export const TranslationsDraftToliveFields = {
  draftVersionComment: {
    name: "DRAFT VERSION COMMENTS",
    value: "",
    rules: {
      title: "DRAFT VERSION COMMENTS",
      required: { required: false },
    },
    
    hideCharCount: true,
    display: false,
  }
};

export const TranslationsRevertliveFields = {
  currentLiveVersion: {
    name: "CURRENT LIVE VERSION",
    value: "",
    rules: { title: "CURRENT LIVE VERSION", required: true },
  },
  revertVersionTo: {
    name: "REVERT VERSION TO",
    value: "",
    rules: { title: "REVERT VERSION TO", required: true },
  },
};

export const countryMenuFields = {
  country: {
    name: "Country",
    value: "",
    rules: { title: "Country/Region", required: true },
  },
  loginUserType: {
    name: "UserType",
    value: "",
    rules: { title: "User Type", required: true },
  },
};



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/ManageTranslationField.js